module.exports = __webpack_public_path__ + "img/Mask-WatercolorTop-2.5f7cc037.png";